import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { IconComponent } from '@claas/claas-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { EventTrackingService } from '@cde-fe-app/app/shared/services/event-tracking.service';
import { IAppLauncherFastAccessDescription } from '../app-launcher.source';

@Component({
  selector: 'app-app-launcher-fast-access-entry',
  templateUrl: './app-launcher-fast-access-entry.component.html',
  styleUrls: ['./app-launcher-fast-access-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, IconComponent],
})
export class AppLauncherFastAccessEntryComponent {
  readonly eventTrackingService = inject(EventTrackingService);
  @Input() fastAccessDescription: IAppLauncherFastAccessDescription;

  public openFastAccessEntry() {
    if (this.fastAccessDescription.trackEventNew != null) {
      this.eventTrackingService.eventTrackNew({ payload: this.fastAccessDescription.trackEventNew });
    }
    window.location.replace(this.fastAccessDescription.link);
  }
}
